import { __assign, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { colorArray } from '@metro-ui/tokens/js';
import { ButtonBase } from './components/ButtonBase';
import { iconSizeMap } from './utils';
import { classNames } from '../utils/stringUtils';
import styles from './Button.module.css';
import tokens from '@metro-ui/tokens/css/custom-properties.module.css';
import { colorTokenToHex } from '@metro-ui/tokens/utils';
export var IconButton = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, _d = _a.size, size = _d === void 0 ? 'large' : _d, Icon = _a.Icon, color = _a.color, hoverBackgroundColor = _a.hoverBackgroundColor, hoverColor = _a.hoverColor, hasNoInteractionEffect = _a.hasNoInteractionEffect, _e = _a.className, className = _e === void 0 ? '' : _e, buttonProps = __rest(_a, ["variant", "size", "Icon", "color", "hoverBackgroundColor", "hoverColor", "hasNoInteractionEffect", "className"]);
    var iconSize = size === 'label' ? iconSizeMap.small : iconSizeMap[size];
    var spinnerSize = size === 'x-large' ? 'medium' : 'small';
    var iconButtonClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompButton] = true,
        _b[styles.mdsCompIconButton] = true,
        _b[styles.hasNoInteractionEffect] = !!hasNoInteractionEffect,
        _b[styles[variant]] = true,
        _b[styles[size]] = true,
        _b[className] = !!className,
        _b));
    var customStyles = __assign(__assign(__assign({}, (color && { '--mds-comp-button-text-color': colorTokenToHex(color) })), (hoverColor && {
        '--mds-comp-button-text-color-hover': colorTokenToHex(hoverColor),
    })), (hoverBackgroundColor && {
        '--mds-comp-button-background-color-hover': colorTokenToHex(hoverBackgroundColor),
    }));
    return (React.createElement(ButtonBase, __assign({ ref: ref, className: iconButtonClassNames, spinnerSize: spinnerSize, style: customStyles }, buttonProps),
        React.createElement(Icon, { size: iconSize, className: styles.iconButtonIcon, "data-testid": "button-icon" })));
});
IconButton.propTypes = __assign(__assign({}, ButtonBase.propTypes), { size: PropTypes.oneOf(['label', 'small', 'medium', 'large', 'x-large']), variant: PropTypes.oneOf(['primary', 'inverted', 'danger']), color: PropTypes.oneOf(colorArray), hoverBackgroundColor: PropTypes.oneOf(colorArray), hoverColor: PropTypes.oneOf(colorArray), Icon: PropTypes.func.isRequired, label: PropTypes.string.isRequired, hasNoInteractionEffect: PropTypes.bool, isWaiting: PropTypes.bool, isWaitingCallback: PropTypes.func, isBeforeValidation: PropTypes.bool, isBeforeValidationCallback: PropTypes.func });
//# sourceMappingURL=IconButton.js.map